import { baseUrl } from "../../../../boot";
import axios from "axios";
import { createAsyncThunk } from "@reduxjs/toolkit";
// add collection  API

export const addPurchaseOder = createAsyncThunk(
  "client/create-purchase-order",
  async (data, { rejectWithValue }) => {
    const token = localStorage.getItem("authToken");

    try {
      const response = await axios.post(
        `${baseUrl}vancouverapis/admin/purchaseOrder/api/v1/create-purchase-order`,
        data,
        {
          headers: {
            "auth-token": token,
          },
        }
      );
      console.log("add purchse response ", response);
      return response; // ✅ Return only the data
    } catch (error) {
      console.error("Error fetching products:", error);

      // ✅ Handle errors properly
      return rejectWithValue(
        error.response?.data?.message || "Failed to fetch products"
      );
    }
  }
);

// update productorder

export const updatePurchaseOder = createAsyncThunk(
  "client/update-purchase-order",
  async (data, { rejectWithValue }) => {
    const token = localStorage.getItem("authToken");
    const rowid = data.ROWID;
    console.log(rowid);

    try {
      const response = await axios.put(
        `${baseUrl}vancouverapis/admin/purchaseOrder/api/v1/update-purchase-order/${rowid}`,
        data,
        {
          headers: {
            "auth-token": token,
          },
        }
      );
      console.log("update purchse response ", response);
      return response; // ✅ Return only the data
    } catch (error) {
      console.error("Error fetching products:", error);

      // ✅ Handle errors properly
      return rejectWithValue(
        error.response?.data?.message || "Failed to fetch products"
      );
    }
  }
);

// delete productorder

export const deletePurchaseOder = createAsyncThunk(
  "client/delete-purchase-order",
  async (data, { rejectWithValue }) => {
    const token = localStorage.getItem("authToken");
    console.log(data);
    try {
      const response = await axios.post(
        `${baseUrl}vancouverapis/admin/purchaseOrder/api/v1/delete-purchase-order/${data}`,
        {
          headers: {
            "auth-token": token,
          },
        }
      );
      console.log("delete purchse response ", response);
      return response; // ✅ Return only the data
    } catch (error) {
      console.error("Error fetching products:", error);

      // ✅ Handle errors properly
      return rejectWithValue(
        error.response?.data?.message || "Failed to fetch products"
      );
    }
  }
);

// bulk delete

export const bulkDeletePurchaseOrder = createAsyncThunk(
  "client/delete-purchase-order",
  async (data, { rejectWithValue }) => {
    const token = localStorage.getItem("authToken");
    console.log(data);
    try {
      const response = await axios.post(
        `${baseUrl}vancouverapis/admin/purchaseOrder/api/v1/delete-purchase-order`,
        data,
        {
          headers: {
            "auth-token": token,
          },
        }
      );
      console.log("bulk delete purchse response ", response);
      return response; // ✅ Return only the data
    } catch (error) {
      console.error("Error fetching products:", error);

      // ✅ Handle errors properly
      return rejectWithValue(
        error.response?.data?.message || "Failed to fetch products"
      );
    }
  }
);

// get count

export const getPurchaseOrderCount = createAsyncThunk(
  "client/purchase-order-count",
  async (data, { rejectWithValue }) => {
    const token = localStorage.getItem("authToken");

    try {
      const response = await axios.post(
        `${baseUrl}vancouverapis/admin/purchaseOrder/api/v1/purchase-order-count`,
        {
          headers: {
            "auth-token": token,
          },
        }
      );
      console.log("get purchase order count response ", response);
      return response; // ✅ Return only the data
    } catch (error) {
      console.error("Error fetching products:", error);

      // ✅ Handle errors properly
      return rejectWithValue(
        error.response?.data?.message || "Failed to fetch products"
      );
    }
  }
);
